<template>
    <div class="comic-dialog">
        <div class="title">
            <template v-if="correct">答對囉！</template>
            <template v-else>答錯囉⋯</template>
        </div>
        <div class="divider"></div>
        <div class="description">{{ explanation }}</div>
        <div class="divider"></div>
        <template v-if="showActions">
            <button class="active" @click="$emit('detail')">
                看解析了解更多
            </button>
            <button @click="$emit('back')">返回關卡</button>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        correct: Boolean,
        explanation: String,
        showActions: Boolean,
    },
};
</script>

<style lang="scss" scoped>
@import "@/scss/comic-dialog.scss";
</style>
